import React from 'react'
import { Outlet } from 'react-router-dom'

export const HerdManagement: React.FC = () => {
  return <Outlet />
}
